export default {
    distinct(array) {
        return [...new Set(array)];
    },

    newOrConcat(array, element) {
        return this.isNullOrEmpty(array) ? [element] : array.concat([element]);
    },

    toggle(element, array) {
        if (this.isNullOrEmpty(array)) {
            return [ element ];
        }
        
        if (!array.includes(element)) {
            return array.concat([ element ])
        }
        
        return array.filter((x) => x !== element);
    },

    anyTrue(arrayOfBooleans) {
        return arrayOfBooleans.some(Boolean);
    },

    isNullOrEmpty(array) {
        return !array || array === null || !Array.isArray(array) || array.length === 0;
    },

    setStateArrayItemProperty(id, key, value, setStateFunction) {
        setStateFunction(prevState => {
            const index = prevState.findIndex(item => item.id === id)
            if (index > -1) {
                const updatedItem = { ...prevState[index], [key]: value }
                const newArray = prevState.toSpliced(index, 1, updatedItem)
                return newArray
            }
            return prevState      
        })
    },

    handleListSelection(checked, element, setSelectedElements, selectedElements, originalList, isSelectAllChecked, setIsSelectAllChecked) {
        if (checked) {
            setSelectedElements(prevState => [...prevState, element.id])
            if (!this.isNullOrEmpty(originalList) && originalList.length - selectedElements.length === 1) {
                setIsSelectAllChecked(true)
            }
        } else {
            const index = selectedElements.findIndex(item => item === element.id)
            setSelectedElements(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllChecked) {
                setIsSelectAllChecked(false)
            }
        }
    },

    handleSelectAll(event, isSelectAllChecked, setIsSelectAllChecked, onClearList, onFillList) {
        setIsSelectAllChecked(!isSelectAllChecked)
        if (event.target.checked) {
            onFillList()
        } else if (!event.target.checked) {
            onClearList()
        }
    }
}